var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c(_setup.UserForm,{attrs:{"userId":_vm.userId}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h1',[_vm._v("Edit User")]),_c('hr')])
}]

export { render, staticRenderFns }